/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solution_Benefit_3Inputs */

const en_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read anything in a language you're comfortable with`)
};

const de_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeden Inhalt in einer vertrauten Sprache lesen`)
};

const zh_tw_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用熟悉的語言讀任何內容`)
};

const zh_cn_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用熟悉的语言读任何内容`)
};

const es_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lee cualquier contenido en un idioma que te resulte familiar`)
};

const fr_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lis n'importe quel contenu dans une langue familière`)
};

const it_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi qualsiasi contenuto in una lingua familiare`)
};

const pt_br_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia qualquer conteúdo num idioma que você domina`)
};

const ja_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どんな内容も、慣れた言語で読める`)
};

const ko_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 콘텐츠든 익숙한 언어로 읽기`)
};

const ru_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Читай любой контент на понятном языке`)
};

const th_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อ่านทุกเนื้อหาในภาษาที่คุ้นเคย`)
};

const tr_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her içeriği aşina olduğun dilde oku`)
};

const ar_solution_benefit_3 = /** @type {(inputs: Solution_Benefit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اقرأ أي محتوى بلغتك المألوفة`)
};

/**
* | output |
* | --- |
* | "Read anything in a language you're comfortable with" |
*
* @param {Solution_Benefit_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const solution_benefit_3 = /** @type {((inputs?: Solution_Benefit_3Inputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solution_Benefit_3Inputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_solution_benefit_3(inputs)
	if (locale === "de") return de_solution_benefit_3(inputs)
	if (locale === "zh_tw") return zh_tw_solution_benefit_3(inputs)
	if (locale === "zh_cn") return zh_cn_solution_benefit_3(inputs)
	if (locale === "es") return es_solution_benefit_3(inputs)
	if (locale === "fr") return fr_solution_benefit_3(inputs)
	if (locale === "it") return it_solution_benefit_3(inputs)
	if (locale === "pt_br") return pt_br_solution_benefit_3(inputs)
	if (locale === "ja") return ja_solution_benefit_3(inputs)
	if (locale === "ko") return ko_solution_benefit_3(inputs)
	if (locale === "ru") return ru_solution_benefit_3(inputs)
	if (locale === "th") return th_solution_benefit_3(inputs)
	if (locale === "tr") return tr_solution_benefit_3(inputs)
	return ar_solution_benefit_3(inputs)
});